export const getPromoBanners = (banners) => {
  const bannersObj = [];
  banners?.forEach((banner, index) => {
    let PromoJson = {
      ...banner,
      type: "image",
      // eslint-disable-next-line
      redirectUrl: "javascript:void(0);",
      imgSrcSet: [],
      imgSrc: "",
      title: "",
      youTubeLink: "",
      videoType: "",
    };
    if (banner.bannerType!=="heroBanner") {
      banner?.properties?.reverse().forEach((prop) => {
        if (prop.name === "promo_banner_l_1280_580") {
          PromoJson["imgSrc"] = prop.value;
        }
        if (prop.name === "promo_banner_l_2560_580" && prop.value.length > 0) {
          PromoJson["imgSrcSet"].push(prop.value + " 2560w");
        }
        if (prop.name === "promo_banner_l_1280_580" && prop.value.length > 0) {
          PromoJson["imgSrcSet"].push(prop.value + " 1980w");
          // PromoJson["imgSrcSet"].push(prop.value + " 1600w");
        }
        if (prop.name === "promo_banner_l_1024_440" && prop.value) {
          PromoJson["imgSrcSet"].push(prop.value + " 1024w");
        }
        if (prop.name === "promo_banner_l_767_440" && prop.value) {
          PromoJson["imgSrcSet"].push(prop.value + " 767w");
        }
        if (prop.name === "promo_banner_m_1220_686" && prop.value) {
          PromoJson["imgSrcSet"].push(prop.value + " 1220w");
        }
        if (prop.name === "promo_banner_m_610_343" && prop.value) {
          PromoJson["imgSrcSet"].push(prop.value + " 610w");
        }
        if (prop.name === "content_type") {
          PromoJson["type"] = prop.value;
        }
        if (prop.name === "title") {
          PromoJson["title"] = prop.value;
        }

        if (prop.name === "video_url" && prop.value.length > 0) {
          PromoJson["youTubeLink"] = prop.value;
        }
        if (prop.name === "poster") {
          PromoJson["video_poster_frame_url"] = prop.value;
        }
        if (prop.name === "video_poster_frame_url" && prop.value.length > 0) {
          PromoJson["imgSrc"] = prop.value;
        }
        if (prop.name === "video_type") {
          PromoJson["videoType"] = prop.value;
        }
        if (prop.name === "video_poster") {
          PromoJson["imgSrc"] = prop.value;
        }
        if (prop.name === "url" && prop.value.length > 0) {
          PromoJson["youTubeLink"] = prop.value;
        }
        if (prop.name === "video" && prop.value.length > 0) {
          PromoJson["youTubeLink"] = prop.value;
        }
      });
    }
    if(banner.bannerType==="heroBanner"){
      banner?.properties?.forEach((prop) => {
        if (prop.name === "hero_banner_1280_300") {
          PromoJson["imgSrc"] = prop.value;
     //     PromoJson["imgSrcSet"].push(prop.value + " 1280w");
        }
        if (prop.name === "hero_banner_2560_460" && prop.value.length > 0) {
          PromoJson["imgSrcSet"].push(prop.value + " 2560w");
        }
        if (prop.name === "hero_banner_1280_300" && prop.value) {
          PromoJson["imgSrcSet"].push(prop.value + " 1280w");
        }
        if (prop.name === "hero_banner_767_300" && prop.value) {
          PromoJson["imgSrcSet"].push(prop.value + " 767w");
        }
        // if (prop.name === "hero_banner_1024_300" && prop.value) {
        //   PromoJson["imgSrcSet"].push(prop.value + "1024w");
        // }


        if (prop.name === "title") {
          PromoJson["title"] = prop.value;
        }
        if (prop.name === "content_type") {
          PromoJson["type"] = prop.value;
        }
      });
    }
    bannersObj.push(PromoJson);
  });

  return bannersObj;
};
